import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface SnbQuotesStoreState {
  quoteData: any;
  quoteHistoryData: any;
  quoteHistoryDataTotalRecords: number;
  serialNumberOptions: any;
  serviceNameOptions: any;
  skuOptions: any;
}
export default {
  state: {
    quoteData: undefined,
    quoteHistoryData: undefined,
    quoteHistoryDataTotalRecords: 0,
    serialNumberOptions: [],
    serviceNameOptions: [],
    skuOptions: [],
  },
  mutations: {
    quoteHistoryDataMutant(state, payload) {
      state.quoteHistoryData = payload;
    },
    quoteHistoryDataTotalRecordsMutant(state, payload) {
      state.quoteHistoryDataTotalRecords = payload;
    },
    quoteDataMutant(state, payload) {
      state.quoteData = payload;
    },
    setSerialNumberOptions(state, payload) {
      state.serialNumberOptions = payload;
    },
    setServiceNameOptions(state, payload) {
      state.serviceNameOptions = payload;
    },
    setSkuOptions(state, payload) {
      state.skuOptions = payload;
    },
  },
  actions: {
    // tslint:disable-next-line:no-unused
    getQuoteHistory(context: ActionContext<SnbQuotesStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/get-quote-history';
      return ApiServiceWrapper.get(endpoint);
    },
    setQuoteHistoryData(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('quoteHistoryDataMutant', payload);
    },
    setQuoteHistoryDataTotalRecords(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('quoteHistoryDataTotalRecordsMutant', payload);
    },
    setQuoteForDetails(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('quoteDataMutant', payload);
    },
    getQuoteForDetails(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const { quoteID, isquotereceipt } = payload;
      let endpoint;
      if (isquotereceipt) {
        endpoint = `quote/get?quoteid=${quoteID}&isquotereceipt=${isquotereceipt}`;
      } else {
        endpoint = `quote/get?quoteid=${quoteID}`;
      }
      if (payload.params) {
        for (const key in payload.params) {
          if (key.toLowerCase() !== 'equoteid') {
            // tslint:disable-next-line
            endpoint += '&' + key.toLowerCase() + '=' +  payload.params[key];
          }
        }
      }
      return ApiServiceWrapper.get(endpoint);
    },
    addEquoteItems(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/add-equote-item';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    createNewQuote(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/create-new-quote';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    updateQuoteDetail(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/update-quote';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    quoteAutoRenew(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/update-auto-renew';
      return ApiServiceWrapper.put(endpoint, payload);
    },
    deleteQuoteItem(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/quoteitem/remove';
      return ApiServiceWrapper.delete(endpoint, payload);
    },
    getPartnerSerialNumbers(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `getpartnerorgserials?quoteID=${payload.quoteID}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getServiceInfo(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/serviceinfo?serial=${payload.serial}&equoteid=${payload.equoteid}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getServiceList(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `order/get-service-list?serviceId=${payload.serviceId}&productId=&serialNumber=${payload.serialNumber}&ssipn=&equoteid=${payload.equoteid}`;
      return ApiServiceWrapper.get(endpoint);
    },
    moveToBasket(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/move-to-basket';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    declineQuote(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/decline-quote';
      return ApiServiceWrapper.put(endpoint, payload);
    },
    requestChange(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/request-change';
      return ApiServiceWrapper.put(endpoint, payload);
    },
    emailQuote(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/email-quote';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    updateYearInDetailPage(context: ActionContext<SnbQuotesStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/update-equoteitems-ssipn';
      return ApiServiceWrapper.put(endpoint, payload);
    },
  },
  getters: {
    getQuoteData: state => state.quoteData,
    getQuoteHistoryData: state => state.quoteHistoryData,
    getAllQuoteHistoryData: state => state.quoteHistoryData,
    getQuoteHistoryDataTotalRecords: state => state.quoteHistoryDataTotalRecords,
    getSerialNumberOptions: state => state.serialNumberOptions,
    getServiceNameOptions: state => state.serviceNameOptions,
    getSkuOptions: state => state.skuOptions,
  },
  namespaced: true,
} as Module<SnbQuotesStoreState, RootStoreState>;
